import Chart from "react-apexcharts";
import { colors } from "../../GlobalDashboardPage";

interface IDonutChartProps {
  labels: string[];
  series: number[];
}

const DonutChart = ({ labels, series }: IDonutChartProps) => {
  const options: ApexCharts.ApexOptions = {
    chart: {
      type: "donut",
    },
    labels: labels,
    colors: Object.values(colors),
    legend: {
      position: "bottom",
    },
  };

  return <Chart options={options} series={series} type="donut" height={"90%"} />;
};

export default DonutChart;
